/* Ripken Paket-Produktseite: Kacheln, Preisbox, Paketinhalt, Sticky-Leiste */
(function () {
  // Gleiches Format wie die Shop-Preise (z. B. "€62,97")
  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    var format = (window.theme && window.theme.moneyFormat) || '';
    if (format.indexOf('{{') > -1) return format.replace(/\{\{\s*[\w]+\s*\}\}/, amount);
    return amount + ' €';
  }

  function init(root) {
    if (root.getAttribute('data-rp-init')) return;
    root.setAttribute('data-rp-init', '1');

    function setText(selector, text) {
      var el = root.querySelector(selector);
      if (el) el.textContent = text;
    }

    function apply(variant) {
      if (!variant) return;
      var tile = root.querySelector('.rp-tile[data-variant-id="' + variant.id + '"]');
      var tiles = root.querySelectorAll('.rp-tile');
      for (var i = 0; i < tiles.length; i++) tiles[i].classList.toggle('is-active', tiles[i] === tile);

      var einzel = tile ? parseInt(tile.getAttribute('data-einzel') || '0', 10) : 0;
      var count = tile ? parseInt(tile.getAttribute('data-count') || '0', 10) : 0;
      var name = tile ? tile.getAttribute('data-name') : variant.title;

      setText('[data-rp-now]', money(variant.price));

      var was = root.querySelector('[data-rp-was]');
      if (was) {
        if (einzel > variant.price) {
          var s = was.querySelector('s');
          if (s) s.textContent = money(einzel);
          was.hidden = false;
        } else {
          was.hidden = true;
        }
      }

      // Ersparnis in Angebotsrot, Preis pro Spezialität grau in der Steuerzeile
      var save = root.querySelector('[data-rp-save]');
      if (save) {
        if (einzel > variant.price) save.textContent = 'Du sparst ' + money(einzel - variant.price);
        save.hidden = !(einzel > variant.price);
      }
      var per = root.querySelector('[data-rp-per]');
      if (per) {
        if (count > 0) per.textContent = ' · ' + money(Math.round(variant.price / count)) + ' pro Spezialität';
        per.hidden = !(count > 0);
      }

      var contents = root.querySelectorAll('[data-rp-contents]');
      for (var j = 0; j < contents.length; j++) {
        contents[j].hidden = contents[j].getAttribute('data-rp-contents') !== String(variant.id);
      }

      setText('[data-rp-picked]', name);
      setText('[data-rp-sticky-name]', name);
      setText('[data-rp-sticky-price]', money(variant.price));
    }

    root.addEventListener('variant:changed', function (event) {
      apply(event.detail && event.detail.variant);
    });

    // Feste Kaufleiste: erscheint, solange der Kaufbutton nicht im Bild ist (darunter oder schon vorbei),
    // und verschwindet wieder beim Schluss-Aufruf (der hat einen eigenen Button)
    var sticky = root.querySelector('[data-rp-sticky]');
    var atc = root.querySelector('.product-form__add-button');
    if (sticky && atc) {
      sticky.hidden = false;
      var ticking = false;
      var update = function () {
        ticking = false;
        var rect = atc.getBoundingClientRect();
        var passed = rect.bottom < 0 || rect.top > window.innerHeight;
        var cta = document.querySelector('.rp-cta');
        var atEnd = cta ? cta.getBoundingClientRect().top < window.innerHeight : false;
        sticky.classList.toggle('is-visible', passed && !atEnd);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
      update();
      var stickyButton = sticky.querySelector('[data-rp-sticky-atc]');
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          if (!atc.disabled) atc.click();
        });
      }
    }
  }

  function selectVariant(id) {
    var radio = document.querySelector('.rp-tile[data-variant-id="' + id + '"] .product-form__single-selector');
    if (!radio || radio.disabled) return false;
    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var target = document.querySelector('.rp-pick') || radio;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ? event.target.closest('[data-rp-select-variant]') : null;
    if (!trigger) return;
    if (selectVariant(trigger.getAttribute('data-rp-select-variant'))) event.preventDefault();
  });

  function boot() {
    var roots = document.querySelectorAll('[data-rp-main]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
